import gsap from "gsap";

import Movie from "./classes/movie.es6";
import FullDive from "./anime/fulldive";
import Accordion from "./modal/accordion";
import Tab from "./classes/tab";
import Goods from "./goods.es6";

import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

//swiper
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import { getParam } from "../../common/functions/get_param.es6";

export default class Main {
    constructor() {
        this.goods = new Goods();
        this._init();
    }

    _init() {
        this.fulldive = new FullDive();
        this.movie = new Movie();
        this.accordion = new Accordion();
        this.tab = new Tab();

        this.scrollNav();
        this.footerIN();
        this.swiper();
    }

    scrollNav() {
        const footer = document.querySelector(".l-footer");
        const nav = document.querySelector(".eventmain__nav");

        if (!footer || !nav) {
            return;
        }

        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0,
        };

        const callback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    nav.classList.remove("-active");
                } else {
                    nav.classList.add("-active");
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);
        observer.observe(footer);

        //パラメーターで初期遷移させる
        const param = getParam("cont");

        if (param) {
            setTimeout(() => {
                const target = `#${param}`;
                const offset =
                    window.innerWidth <= 768
                        ? window.innerWidth * 0.3
                        : 200 * (window.innerWidth / 1920);
                gsap.to(window, {
                    duration: 1,
                    scrollTo: { y: target, offsetY: offset },
                    ease: "circ.inOut",
                });
            }, 1000);
        }
    }

    footerIN() {
        const footeritem = document.querySelectorAll(
            ".l-footer__inner .js-scrollreveal"
        );

        const footerline = document.querySelectorAll(
            ".l-footer__line_wrap .js-scrollreveal"
        );

        footeritem.forEach(($target) => {
            $target.classList.add("-reveal");
        });
        footerline.forEach(($target) => {
            $target.classList.add("-reveal");
        });
    }

    swiper() {
        const swipers = [...document.querySelectorAll(".js-swiper")];

        //.swiperでクラスをつけないで、DOMそれぞれにswiperを作成
        swipers.forEach((el) => {
            const parent = el.closest(".js-swiper_wrap");
            const thumbs = parent && parent.querySelector(".js-swiper_thumb");

            if (thumbs) {
                const thumbSlider = new Swiper(thumbs, {
                    slidesPerView: "auto",
                    spaceBetween: 4,
                });

                const swiper = new Swiper(el, {
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    thumbs: {
                        swiper: thumbSlider,
                    },
                });
            } else {
                const swiper = new Swiper(el, {
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            }
        });
    }
}
